export default {
  "de": {
    "container-search": {
      "categories": "KATEGORIEN",
      "collection": "Kollektion",
      "colours": "Farbe",
      "FEMALE": "Damen",
      "gender": "Geschlecht",
      "Here are a few alternate destinations that might help.": "Hier finden Sie ein paar alternative Vorschläge, die Ihnen helfen könnten.",
      "In Stock": "Auf lager",
      "Items": "Artikel",
      "MALE": "Herren",
      "materials": "Materialien",
      "Name (A→Z)": "Name (A→Z)",
      "Name (Z→A)": "Name (Z→A)",
      "natural": "",
      "NEUTRAL": "Unisex",
      "Price (High→Low)": "Preis (absteigend)",
      "Price (Low→High)": "Preis (aufsteigend)",
      "properties": "Eigenschaften",
      "rating": "Beurteilung",
      "Refine": "Filter",
      "Search": "Suchen",
      "Search Result": "Es werden {{nbHits}} Suchergebnisse für „<0>{{query}}</0>” angezeigt",
      "showing results for": "Ergebnisse anzeigen für",
      "Sort": "Sortieren",
      "Top Rated": "Am besten bewertet",
      "We couldn't find any products that match your search.": "Wir können für Ihre Suche keine passenden Produkte finden.",
      "Weight (Low→High)": "Gewicht (aufsteigend)",
      "What's New": "Was ist neu"
    }
  },
  "en": {
    "container-search": {
      "categories": "Categories",
      "collection": "",
      "colours": "Colours",
      "FEMALE": "Women",
      "gender": "Gender",
      "Here are a few alternate destinations that might help.": "",
      "In Stock": "",
      "Items": "",
      "MALE": "Men",
      "materials": "Materials",
      "Name (A→Z)": "",
      "Name (Z→A)": "",
      "natural": "",
      "NEUTRAL": "Unisex",
      "Price (High→Low)": "",
      "Price (Low→High)": "",
      "properties": "",
      "rating": "Rating",
      "Refine": "",
      "Search": "",
      "Search Result": "Showing {{nbHits}} search results for '<0>{{query}}</0>'",
      "showing results for": "",
      "Sort": "",
      "Top Rated": "",
      "We couldn't find any products that match your search.": "",
      "Weight (Low→High)": "",
      "What's New": ""
    }
  },
  "es": {
    "container-search": {
      "categories": "CATEGORÍAS",
      "collection": "Colección",
      "colours": "Colores",
      "FEMALE": "Mujeres",
      "gender": "Sexo",
      "Here are a few alternate destinations that might help.": "Aquí le dejamos unos destinos alternativos que pueden servirle de ayuda.",
      "In Stock": "disponible",
      "Items": "Artículos",
      "MALE": "Hombres",
      "materials": "Materiales",
      "Name (A→Z)": "Nombre (A→Z)",
      "Name (Z→A)": "Nombre (Z→A)",
      "natural": "",
      "NEUTRAL": "Unisexo",
      "Price (High→Low)": "Precio (primero→más)",
      "Price (Low→High)": "Precio (más→primero)",
      "properties": "Propiedades",
      "rating": "Calificación",
      "Refine": "Restringir",
      "Search": "Buscar",
      "Search Result": "Mostrando {{nbHits}} resultados de búsqueda de '<0>{{query}}</0>'",
      "showing results for": "Mostrar resultados por",
      "Sort": "Ordenar",
      "Top Rated": "Mejor valorados",
      "We couldn't find any products that match your search.": "No se ha encontrado ningún producto que coincida con su búsqueda.",
      "Weight (Low→High)": "Peso (más→primero)",
      "What's New": "Novedades"
    }
  },
  "fr": {
    "container-search": {
      "categories": "CATÉGORIES",
      "collection": "Collection",
      "colours": "Couleurs",
      "FEMALE": "Femme",
      "gender": "Sexe",
      "Here are a few alternate destinations that might help.": "Voici quelques alternatives qui pourraient vous aider.",
      "In Stock": "en stock",
      "Items": "Articles",
      "MALE": "Homme",
      "materials": "Matières",
      "Name (A→Z)": "Nom (A→Z)",
      "Name (Z→A)": "Nom (Z→A)",
      "natural": "",
      "NEUTRAL": "Unisexe",
      "Price (High→Low)": "Prix (élevée→bas)",
      "Price (Low→High)": "Prix (bas→élevée)",
      "properties": "Caractéristiques",
      "rating": "Note",
      "Refine": "Affiner",
      "Search": "Recherche",
      "Search Result": "{{nbHits}} résultats de recherche affichés pour '<0>{{query}}</0>'",
      "showing results for": "Afficher les résultats pour",
      "Sort": "Trier",
      "Top Rated": "Les mieux notés",
      "We couldn't find any products that match your search.": "Nous n’avons trouvé aucun produit correspondant à votre recherche.",
      "Weight (Low→High)": "Poids (bas→élevée)",
      "What's New": "Nouveautés"
    }
  },
  "jp": {
    "container-search": {
      "categories": "カテゴリー",
      "collection": "コレクション",
      "colours": "色",
      "FEMALE": "ウィメンズ",
      "gender": "性別",
      "Here are a few alternate destinations that might help.": "以下の場所もご覧になりますか？",
      "In Stock": "在庫あり",
      "Items": "アイテム",
      "MALE": "メンズ",
      "materials": "素材",
      "Name (A→Z)": "名前順 (A → Z)",
      "Name (Z→A)": "名前順 (Z → A)",
      "natural": "",
      "NEUTRAL": "ユニセックス",
      "Price (High→Low)": "価格順 (高→低)",
      "Price (Low→High)": "価格順 (低→高)",
      "properties": "特性",
      "rating": "評価",
      "Refine": "絞り込む",
      "Search": "検索",
      "Search Result": "「<0>{{query}}</0>」の検索結果 {{nbHits}}件を表示しています",
      "showing results for": "検索結果を表示します。",
      "Sort": "並べ替え",
      "Top Rated": "最高評価",
      "We couldn't find any products that match your search.": "検索用語と一致する商品は見つかりませんでした。",
      "Weight (Low→High)": "重さ",
      "What's New": "新商品"
    }
  },
  "no": {
    "container-search": {
      "categories": "KATEGORIER",
      "collection": "Kolleksjon",
      "colours": "Farger",
      "FEMALE": "Dame",
      "gender": "Kjønn",
      "Here are a few alternate destinations that might help.": "Her er noen andre steder som kanskje kan hjelpe.",
      "In Stock": "på lager",
      "Items": "Varer",
      "MALE": "Herre",
      "materials": "Materialer",
      "Name (A→Z)": "Navn (A→Å)",
      "Name (Z→A)": "Navn (Å→A)",
      "natural": "",
      "NEUTRAL": "Unisex",
      "Price (High→Low)": "Pris (høy→lav)",
      "Price (Low→High)": "Pris (lav→høy)",
      "properties": "Egenskaper",
      "rating": "Vurdering",
      "Refine": "Begrens",
      "Search": "Søk",
      "Search Result": "See {{nbHits}} søkeresultater for '<0>{{query}}</0>'",
      "showing results for": "Viser resultater for",
      "Sort": "Sorter",
      "Top Rated": "Toppkarakter",
      "We couldn't find any products that match your search.": "Vi fant ingen produkter som oppfyller søkekriteriene dine.",
      "Weight (Low→High)": "Vekt (lav→høy)",
      "What's New": "Nyheter"
    }
  },
  "zh": {
    "container-search": {
      "categories": "分类",
      "collection": "系列",
      "colours": "颜色",
      "FEMALE": "女装",
      "gender": "性别",
      "Here are a few alternate destinations that might help.": "以下是一些可能有帮助的目的地。",
      "In Stock": "有货",
      "Items": "物品",
      "MALE": "男装",
      "materials": "材料",
      "Name (A→Z)": "名称（A到Z）",
      "Name (Z→A)": "名称（Z到A）",
      "natural": "",
      "NEUTRAL": "男女通用",
      "Price (High→Low)": "价格（从高到低）",
      "Price (Low→High)": "价格（从低到高）",
      "properties": "属性",
      "rating": "评级",
      "Refine": "细化",
      "Search": "搜索",
      "Search Result": "显示'<0>{{query}}</0>'的{{nbHits}}个搜索结果",
      "showing results for": "显示结果",
      "Sort": "分类",
      "Top Rated": "最佳产品",
      "We couldn't find any products that match your search.": "我们无法找到任何与搜索匹配的产品。",
      "Weight (Low→High)": "按重量（从低到高）",
      "What's New": "查看新品"
    }
  }
};
